<div class="calculator property-radio-group">
    <dx-text-box class="calculator-screen" [disabled]="true" [(value)]="inputValue"></dx-text-box>

    <div class="calculator-keys">
        <dx-button class="all-clear" (onClick)="onClear()">C</dx-button>
        <dx-button class="all-clear" (onClick)="onAllClear()">AC</dx-button>
        <dx-button class="operator cal-btn" (onClick)="onOperatorClick('%')">%</dx-button>
        <dx-button class="operator cal-btn" (onClick)="onOperatorClick('/')">/</dx-button>

        <dx-button class="cal-btn" (onClick)="onNumClick('7')">7</dx-button>
        <dx-button class="cal-btn" (onClick)="onNumClick('8')">8</dx-button>
        <dx-button class="cal-btn" (onClick)="onNumClick('9')">9</dx-button>
        <dx-button class="operator cal-btn" (onClick)="onOperatorClick('*')">*</dx-button>

        <dx-button class="cal-btn" (onClick)="onNumClick('4')">4</dx-button>
        <dx-button class="cal-btn" (onClick)="onNumClick('5')">5</dx-button>
        <dx-button class="cal-btn" (onClick)="onNumClick('6')">6</dx-button>
        <dx-button class="operator cal-btn" (onClick)="onOperatorClick('-')">-</dx-button>

        <dx-button class="cal-btn" (onClick)="onNumClick('1')">1</dx-button>
        <dx-button class="cal-btn" (onClick)="onNumClick('2')">2</dx-button>
        <dx-button class="cal-btn" (onClick)="onNumClick('3')">3</dx-button>
        <dx-button class="operator cal-btn" (onClick)="onOperatorClick('+')">+</dx-button>

        <dx-button class="cal-btn" (onClick)="onNumClick('0')">0</dx-button>
        <dx-button class="decimal" (onClick)="onNumClick('.')">.</dx-button>
        <dx-button class="equal-sign" (onClick)="getAnswer()">=</dx-button>
    </div>
</div>
